import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, switchMap } from 'rxjs';
import { PagedResources } from '../interfaces/paged-resources';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
/**
 * The count of the new Tickets (Shown on Taskpage)
 */
  formCount$: BehaviorSubject<number> = new BehaviorSubject(null);
  /**
   * The constructor for the TicketService
   * Get the formCount(all new Ticktes)
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {
    this.filterTickets(0, 1, null, ["NEW"], null).subscribe((val: PagedResources<any>) => {
      this.formCount$.next(val.page.totalElements)
    })
  }
  /**
   * Filter the Tickets by the Properties
   * @param page 
   * @param size 
   * @param filterByIssueTypes 
   * @param filterByTicketStates 
   * @param searchTerm 
   * @returns 
   */

  filterTickets(page: number, size: number, filterByIssueTypes, filterByTicketStates, searchTerm) {
    const body = {
      filterByIssueTypes: filterByIssueTypes,
      filterByTicketStates: filterByTicketStates,
      searchTerm: searchTerm
    }
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/ticket/search?page=${page}&size=${size}`, body)
      )
    )
  }
  /**
   * Get the Ticket by ID and return a XLS
   * @param ticketID 
   * @returns 
   */
  getTicketAsXLS(ticketID:string ) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/ticket/${ticketID}`, { responseType: 'blob', headers: new HttpHeaders().set('Content-Type', 'application/vnd.ms-excel') })
      )
    )

    // return this.environment.apiV1$.pipe(
    //   switchMap(url => this.http.get(`${url}/event/${event.publicId}/reservation`, { responseType: 'blob', headers: new HttpHeaders().set('Content-Type', 'application/vnd.ms-excel') })
    //   )
    // )

  }

  /**
   * Get a Ticket by its ID
   * @param ticketID 
   * @returns 
   */
  getTicketById(ticketID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/ticket/${ticketID}`, {})
      )
    )
  }



    /**
   * Edit a Ticket by its ID
   * @param ticketID 
   * @returns 
   */
    editTicketById(ticketID,ticketData) {
      return this.environment.apiV1$.pipe(
        switchMap(url => this.http.patch(`${url}/ticket/${ticketID}`, ticketData)
        )
      )
    }
}
